import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Minus, Plus } from "lucide-react";

export type FAQItem = {
  q: string;
  a: string;
  blocks?: { heading: string; text: string }[];
};

const faqs: FAQItem[] = [
  {
    q: "Кто такие WMT AI?",
    a: "Экспертиза WMT в ИИ: WMT AI работает с AI-трансформацией бизнеса, корпоративным обучением, ИИ-агентами и готовыми продуктами. Компания существует с 2019 года, ИИ-направление развивается с 2023 года. Системная работа: команда связывает бизнес-задачи, данные, технологии и подготовку сотрудников в единую программу внедрения. Люди и процессы: руководители и команды осваивают новые способы работы, закрепляют их в процессах и отвечают за измеримый результат.\n\nЗадачи, которые решает WMT AI: лишние расходы из-за неконтролируемых API-вызовов и разрозненной архитектуры, ошибки и задержки в обработке документов, аналитике, согласованиях и коммуникациях, сложный запуск изменений без правил работы с ИИ и подготовки команды, стихийное использование инструментов без связи с ролями и рабочими задачами, потеря корпоративной экспертизы, которая остаётся у отдельных сотрудников.\n\nКогда обращаются к WMT AI: непонятно, с чего начать - определяем исходную точку и собираем последовательный план действий. Инициатив много, приоритетов нет - оцениваем идеи и выбираем сценарии с понятной ценностью для бизнеса. Команда, данные или процессы требуют подготовки - готовим условия для пилота и дальнейшего внедрения. Нужен конкретный результат - подбираем обучение, готовый продукт, разработку или комплексную AI-трансформацию.",
    blocks: [
      {
        heading: "Экспертиза WMT в ИИ",
        text: "WMT AI работает с AI-трансформацией бизнеса, корпоративным обучением, ИИ-агентами и готовыми продуктами. Компания существует с 2019 года, ИИ-направление развивается с 2023 года. Системная работа: команда связывает бизнес-задачи, данные, технологии и подготовку сотрудников в единую программу внедрения. Люди и процессы: руководители и команды осваивают новые способы работы, закрепляют их в процессах и отвечают за измеримый результат.",
      },
      {
        heading: "Задачи, которые решает WMT AI",
        text: "Лишние расходы из-за неконтролируемых API-вызовов и разрозненной архитектуры, ошибки и задержки в обработке документов, аналитике, согласованиях и коммуникациях, сложный запуск изменений без правил работы с ИИ и подготовки команды, стихийное использование инструментов без связи с ролями и рабочими задачами, потеря корпоративной экспертизы, которая остаётся у отдельных сотрудников.",
      },
      {
        heading: "Когда обращаются к WMT AI",
        text: "Непонятно, с чего начать - определяем исходную точку и собираем последовательный план действий. Инициатив много, приоритетов нет - оцениваем идеи и выбираем сценарии с понятной ценностью для бизнеса. Команда, данные или процессы требуют подготовки - готовим условия для пилота и дальнейшего внедрения. Нужен конкретный результат - подбираем обучение, готовый продукт, разработку или комплексную AI-трансформацию.",
      },
    ],
  },
  {
    q: "Как устроена AI-трансформация?",
    a: "Работа начинается с бизнес-задач и измеримых критериев. Затем команда проверяет сценарии, внедряет подходящие решения и закрепляет новые способы работы на основе анализа того, где ИИ создаёт ценность, как меняются роли и процессы и как закрепить изменения в ежедневной работе. В процесс входят управленческие решения, работа с данными, взаимодействие команд и клиентский опыт.\n\nЧтобы начать AI-трансформацию, выберите следующий шаг: обучение ключевых людей - команда осваивает ИИ на реальных задачах и формирует рабочие сценарии; готовое ИИ-решение - продукт или ИИ-агент подключается к конкретному процессу компании; проектная AI-трансформация - решения, архитектура и обучение выстраиваются вокруг процессов и ИТ-контура компании.",
  },
  {
    q: "Как внедрить ИИ в бизнес?",
    a: "Внедрение ИИ в бизнес стоит начинать с конкретного процесса, владельца, данных и измеримой метрики. Затем запускается ограниченный AI-пилот, проверяется качество и экономический эффект, после чего успешный сценарий масштабируется на отдел или компанию. Такой подход снижает риск дорогих ИИ-проектов без результата.",
  },
  {
    q: "С чего начать внедрение ИИ в компании?",
    a: "Первый шаг во внедрении ИИ в компании зависит от текущей зрелости бизнеса. Это может быть стратегическая сессия, диагностика процессов, корпоративное обучение ИИ, разбор уже собранных инициатив или проверка конкретного AI-сценария. Главная задача на старте состоит в выборе обоснованного первого шага.",
  },
  {
    q: "Как выбрать первый бизнес-процесс для внедрения ИИ?",
    a: "Лучше выбирать процесс, где есть понятный владелец, доступные данные, регулярная операция и метрика до внедрения. Подходящий процесс для AI-пилота позволяет быстро проверить время выполнения, качество, количество ручных действий или стоимость операции.",
  },
  {
    q: "Какие процессы в компании можно автоматизировать с помощью ИИ?",
    a: "ИИ подходит для процессов, где сотрудники работают с документами, данными, поиском информации, повторяющимся анализом, коммуникациями и типовыми решениями. Частые сценарии для бизнеса: корпоративный поиск, юридический анализ, обработка документов, рекрутинг, клиентский сервис, аналитика, продажи и внутренние базы знаний.",
  },
  {
    q: "Как понять, где ИИ даст реальный экономический эффект?",
    a: "Экономический эффект от ИИ проще всего оценивать через конкретную операцию. Сравниваются время до и после, стоимость операции, количество ошибок, пропускная способность команды и доля полезных результатов. Финансовый эффект фиксируется после подтверждения исходных данных и причинной связи.",
  },
  {
    q: "Как посчитать ROI от внедрения ИИ?",
    a: "ROI от внедрения ИИ считается от базовой метрики. Нужно зафиксировать текущие затраты времени и денег, стоимость разработки и эксплуатации решения, затем измерить изменение скорости, качества и стоимости процесса. Универсального процента ROI для ИИ нет, экономика считается отдельно для каждого процесса.",
  },
  {
    q: "Сколько стоит внедрение ИИ в компанию?",
    a: "Стоимость внедрения ИИ зависит от сложности процесса, данных, интеграций, требований информационной безопасности и масштаба. В текущей продуктовой модели WMT AI ориентир составляет 5-10 млн рублей для разработки и внедрения одного цифрового сотрудника, 10-25 млн для системы цифровых сотрудников и от 30 млн для комплексной AI-трансформации.",
  },
  {
    q: "Почему ИИ-пилоты не масштабируются?",
    a: "AI-пилоты часто останавливаются из-за отсутствия владельца процесса, базовой метрики, качественных данных, готовности команды или понятной архитектуры. Масштабирование ИИ начинается после проверки качества, эффекта и технических условий на ограниченном участке процесса.",
  },
  {
    q: "Как перейти от пилотов к системному использованию ИИ в компании?",
    a: "После успешного AI-пилота нужно закрепить сценарий в ежедневной работе, обучить пользователей, настроить доступы, интеграции, поддержку и аналитику использования. Затем решение масштабируется на функцию, несколько отделов или единое корпоративное ИИ-пространство.",
  },
  {
    q: "Нужна ли компании отдельная AI-стратегия?",
    a: "AI-стратегия нужна, когда в компании появляется несколько ИИ-инициатив, пилотов и инструментов. Она помогает определить приоритетные процессы, владельцев, правила работы с данными, критерии эффекта и архитектуру дальнейшего масштабирования ИИ.",
  },
  {
    q: "Кто должен отвечать за ИИ-трансформацию внутри компании?",
    a: "ИИ-трансформация требует участия первого лица и владельцев бизнес-процессов. Отдельный CDTO, CIO или Head of AI может управлять программой, но бизнес-эффект должен подтверждать руководитель процесса, который отвечает за результат, данные и внедрение нового сценария в ежедневную работу.",
  },
  {
    q: "Что такое ИИ-агент и когда он нужен бизнесу?",
    a: "ИИ-агент для бизнеса получает задачу, собирает нужный контекст, использует данные и инструменты и доводит работу до заданного результата. Агент нужен там, где есть повторяемый процесс с понятным входом, выходом, правилами и точками контроля.",
  },
  {
    q: "ИИ-агент, чат-бот или обычная автоматизация: что выбрать?",
    a: "Выбор зависит от задачи. Чат-бот подходит для диалога и ответов, обычная автоматизация хорошо работает по жёстким правилам, ИИ-агент полезен в задачах с документами, контекстом, вариативностью и несколькими шагами. Сначала определяется процесс, затем выбирается минимально достаточный тип решения.",
  },
  {
    q: "Как понять, нужен готовый AI-сервис или кастомная разработка?",
    a: "Готовый AI-сервис подходит для типовых задач и быстрого старта. Кастомная разработка ИИ оправдана, если процесс зависит от внутренних данных, корпоративных правил, нескольких систем и требует собственной логики. Иногда оптимальный вариант строится на готовом ядре с доработкой под процесс компании.",
  },
  {
    q: "Как безопасно использовать ChatGPT и другие нейросети в компании?",
    a: "Безопасное использование ИИ в компании начинается с правил работы с данными, разграничения доступов, контроля используемых моделей и понимания, какие документы можно передавать во внешние сервисы. Для чувствительных сценариев отдельно оцениваются закрытый контур, локальное размещение и требования информационной безопасности.",
  },
  {
    q: "Можно ли сотрудникам передавать корпоративные данные в нейросети?",
    a: "Это зависит от типа данных, выбранной модели и внутренних правил компании. Перед запуском корпоративного ИИ нужно определить допустимые данные, правила маскирования, права доступа, хранение информации и согласовать сценарии с ИТ и информационной безопасностью.",
  },
  {
    q: "Как обучить сотрудников работать с ИИ на реальных задачах?",
    a: "Корпоративное обучение ИИ должно строиться вокруг реальной работы сотрудников. Участники разбирают собственные документы, процессы и повторяющиеся задачи, учатся ставить задачи моделям, проверять результаты, работать с данными и создавать рабочие ИИ-сценарии.",
  },
  {
    q: "Как понять, что корпоративное обучение ИИ дало результат?",
    a: "Результат корпоративного обучения ИИ измеряется через реальные рабочие сценарии. Можно смотреть на долю активных пользователей, количество завершённых задач с ИИ, повторное использование сценариев, скорость выполнения операций, качество результата и число инициатив, которые дошли до пилота.",
  },
  {
    q: "Почему сотрудники проходят обучение, но потом перестают пользоваться ИИ?",
    a: "Обычно причина в том, что обучение оторвано от ежедневных задач, отсутствуют готовые сценарии, поддержка и понятные правила работы с данными. Устойчивое использование ИИ появляется, когда обучение связано с реальными процессами, а компания отслеживает adoption и помогает сотрудникам закрепить новые рабочие привычки.",
  },
  {
    q: "Как выбрать подрядчика по внедрению ИИ?",
    a: "При выборе подрядчика по внедрению ИИ стоит смотреть на опыт работы с реальными бизнес-процессами, умение считать эффект, качество пилотов, компетенции в данных, интеграциях и безопасности. Сильный AI-интегратор должен уметь провести путь от диагностики и обучения команды до пилота, внедрения и масштабирования решения.",
  },
];

type FAQSectionProps = {
  items?: FAQItem[];
  sectionId?: string;
};

const FAQSection = ({ items = faqs, sectionId = "faq" }: FAQSectionProps) => {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  useEffect(() => {
    const scriptId = `${sectionId}-faq-schema`;
    document.getElementById(scriptId)?.remove();

    const script = document.createElement("script");
    script.id = scriptId;
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    });
    document.head.appendChild(script);

    return () => script.remove();
  }, [items, sectionId]);

  return (
    <section id={sectionId} className="relative scroll-mt-24 border-t border-border/70 bg-background py-20 sm:py-24 lg:py-28">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl font-heading text-4xl font-medium leading-[1.08] tracking-normal sm:text-5xl lg:text-[56px]"
        >
          Часто задаваемые <span className="text-accent">вопросы</span>
        </motion.h2>

        <div className="mt-10 border-b border-border sm:mt-14">
          {items.map((item, index) => {
            const isOpen = openIdx === index;
            const answerId = `${sectionId}-answer-${index}`;

            return (
              <motion.div
                key={item.q}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35 }}
                className="border-t border-border"
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={answerId}
                  onClick={() => setOpenIdx(isOpen ? null : index)}
                  className="group flex w-full items-start gap-4 py-5 text-left sm:items-center sm:gap-6 sm:py-6"
                >
                  <span className="mt-0.5 w-7 shrink-0 text-sm font-medium tabular-nums text-muted-foreground sm:mt-0 sm:w-8">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="flex-1 text-base font-medium leading-snug text-foreground transition-colors group-hover:text-accent sm:text-lg">
                    {item.q}
                  </span>
                  <span className="flex size-8 shrink-0 items-center justify-center rounded-full border border-border text-accent transition-colors group-hover:border-accent sm:size-9">
                    {isOpen ? <Minus size={18} aria-hidden="true" /> : <Plus size={18} aria-hidden="true" />}
                  </span>
                </button>

                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      id={answerId}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25, ease: "easeOut" }}
                      className="overflow-hidden"
                    >
                      <div className="space-y-4 pb-6 pl-11 pr-12 text-sm leading-relaxed text-muted-foreground sm:pb-7 sm:pl-14 sm:pr-16 sm:text-base">
                        {item.blocks ? item.blocks.map((block) => (
                          <p key={block.heading}>
                            <strong className="font-semibold text-foreground">{block.heading}:</strong>{" "}
                            {block.text}
                          </p>
                        )) : (
                          <p className="whitespace-pre-line">{item.a}</p>
                        )}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
